import React, { useCallback, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../../hooks/notifications';
import api, { setupNotificationInterceptor } from '../../services/api';
import {
  Container,
  NotificationItem,
  NotificationList,
  NotificationTime,
} from './styles';
import { useAuth } from '../../hooks/auth';
import { formatRelativeDate } from '../../utils/formatRelativeDate';
import {
  INotificationItem,
  defaultNotificationIcon,
  mapNotificationToItem,
} from '../../utils/mapNotificationToItem';

const NotificationPanel: React.FC = () => {
  const { user } = useAuth();
  const { notifications, addNotifications } = useNotification();
  const navigate = useNavigate();

  // CORREÇÃO: dependência [notifications] para reagir a novas notificações
  const notificationsItems = useMemo(
    (): INotificationItem[] => notifications.map(mapNotificationToItem),
    [notifications],
  );

  useEffect(() => {
    setupNotificationInterceptor(addNotifications);
  }, [addNotifications]);

  useEffect(() => {
    if (!user) return undefined;

    const timeoutId = setTimeout(() => {
      api
        .get('/notifications')
        .then(response => {
          addNotifications(response.data.notifications);
        })
        // Notificações são acessórias: falhar aqui não pode virar
        // unhandled rejection nem interromper a página.
        .catch(() => undefined);
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [user, addNotifications]);

  const handleNotificationClick = useCallback(
    (notification: INotificationItem) => {
      if (notification.link) {
        navigate(notification.link);
      }
    },
    [navigate],
  );

  return (
    <Container>
      <h1>Notificações</h1>
      <NotificationList>
        {notificationsItems.map(notification => (
          <NotificationItem
            key={notification.id}
            $isClicked={notification.link !== undefined}
          >
            <button
              type="button"
              onClick={() => handleNotificationClick(notification)}
            >
              <img
                src={notification.icon_url || defaultNotificationIcon}
                alt="icon-notification"
              />
              <div>
                <p>
                  <b>{notification.title}</b> {notification.message}
                </p>
                <NotificationTime>
                  {formatRelativeDate(notification.created_at)}
                </NotificationTime>
              </div>
            </button>
          </NotificationItem>
        ))}
      </NotificationList>
    </Container>
  );
};

export default NotificationPanel;
